import axios from "../../../util/payrightAxios";

export const fetchStatementPdf = async (statementId: string): Promise<Blob | null> => {
  try {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const authToken = localStorage.getItem("authToken");
    const customerId = localStorage.getItem("customerId");
    const url = `${apiBaseUrl}/customer/${customerId}/statements/${statementId}`;

    axios.defaults.headers.common["auth-token"] = authToken;

    const response = await axios(url, {
      method: "POST",
      responseType: "blob",
    });

    const contentType = response.headers["content-type"];
    if (contentType && contentType.includes("application/pdf")) {
      return new Blob([response.data], {
        type: "application/pdf",
      });
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};
